import { queryOptions } from '@tanstack/react-query'
import { apiGet } from './client'

/**
 * Jurnalul sesiunilor remote si inregistrarile lor (CEC 65) -
 * `App\RemoteConnect\Sessions\RemoteSessions`:
 *
 *   GET /remote-connect/sessions[?ticket=&device=&from=&to=&page=]
 *   GET /remote-connect/sessions/{id}/recordings/{recordingId}[?download=1]
 *   GET /easeedesk/tickets/{id}/remote-sessions[?page=]   sesiunile unui tichet,
 *       numai daca omul vede tichetul (404 altfel)
 *
 * Lista cere `opteemum.remote_connect_sessions` (sau, numai cu `ticket=`,
 * dreptul filei Remote Connect a tichetului); inregistrarea cere
 * `opteemum.remote_connect_recordings`. Adresa inregistrarii e semnata si
 * scurta (o ora) - nu se tine in cache.
 */

export type RemoteSessionRecording = {
  id: number
  status: 'expected' | 'available' | 'failed' | 'deleted' | 'unknown'
  bytes: number | null
  seconds: number | null
  deleteAfter: string | null
  playable: boolean
}

export type RemoteSessionRow = {
  id: number
  device: { id: number; name: string }
  companyId: number
  operator: { id: number | null; name: string }
  ticketId: number | null
  startedAt: string | null
  endedAt: string | null
  durationSeconds: number | null
  stale: boolean
  stealth: boolean
  access: 'one_time_password' | 'portal_launch' | 'unknown'
  transfers: number
  recordings: RemoteSessionRecording[]
}

export type RemoteSessionsPage = {
  rows: RemoteSessionRow[]
  total: number
  page: number
  pageSize: number
  canPlay: boolean
}

export type RemoteSessionsFilter = {
  ticket?: number
  device?: number
  from?: string
  to?: string
  page?: number
}

export function remoteSessionsQuery(filter: RemoteSessionsFilter) {
  const params = new URLSearchParams()
  for (const [key, value] of Object.entries(filter)) {
    if (value !== undefined && value !== '' && value !== 0) params.set(key, String(value))
  }
  const qs = params.toString()
  return queryOptions({
    queryKey: ['remote-connect', 'sessions', filter],
    queryFn: () => apiGet<RemoteSessionsPage>(`/remote-connect/sessions${qs ? `?${qs}` : ''}`),
  })
}

/** Fila Remote Connect a tichetului: sesiunile pornite de pe el. */
export function ticketRemoteSessionsQuery(ticketId: number, page = 1) {
  const key: RemoteSessionsFilter = { ticket: ticketId, page }
  return queryOptions({
    /* Aceeasi forma de cheie ca `remoteSessionsQuery`, ca tabelul sa le poata
       folosi pe amandoua cu acelasi `useQuery`. */
    queryKey: ['easeedesk', 'ticket-remote-sessions', key],
    queryFn: () => apiGet<RemoteSessionsPage>(`/easeedesk/tickets/${ticketId}/remote-sessions${page > 1 ? `?page=${page}` : ''}`),
  })
}

export type RecordingLink = { url: string; expiresIn: number; fileName: string }

export function recordingLink(sessionId: number, recordingId: number, download: boolean) {
  return apiGet<RecordingLink>(
    `/remote-connect/sessions/${sessionId}/recordings/${recordingId}${download ? '?download=1' : ''}`,
    { cache: 'no-store' },
  )
}
